import styled from '@emotion/styled';
import {colors} from 'ui/config';

export const Unsupported = styled('div')({
  padding: '80px 24px 140px',
  fontSize: 16,
  lineHeight: '24px',
  color: colors.darkBrown,
  textAlign: 'center',
});
